<template>
  <div>
    <b-alert
      id="global_alert_bar"
      dismissible
      :variant="$store.state.global_alert.message.type"
      show
      >{{ $store.state.global_alert.message.text }}</b-alert
    >
  </div>
</template>

<script>
export default {
  name: "GlobalAlert",
  created: function () {
    this.start_closing();
  },
  watch:{
    "$store.state.global_alert.show":function(new_value){
      if(new_value){
        this.start_closing();
      }
    }
  },
  methods: {
    start_closing: function () {
      var self = this;
      setTimeout(function () {
        self.$set(self.$store.state.global_alert, "show", false);
      }, 5000);
    },
  },
};
</script>
<style scoped lang="css">
#global_alert_bar {
  border: none;
  border-radius: 0;
  background: #eb2b2b;
  color: #fff;
  text-shadow: none;
  text-align: center;
  position: fixed;
  width: 100%;
  bottom: 0;
  margin: 0;
  font-weight: bold;
  z-index: 300000;
}

#global_alert_bar .alert-dismissible .close {
  border-radius: 0;
  height: 100%;
}
</style>
